import React, { Component } from 'react'
import { Row, Col, Spinner } from 'reactstrap'
import Producto from '../../utils/producto'
import ProductItem from '../../components/productItem'
import './productosOferta.css'
const prod = new Producto()

export default class SaleProducts extends Component {
    constructor() {
        super()
        this.state = {
            productos: []
        }
    }

    allProducts() {
        const _this = this
        prod.leerProductosOferta().then(productos => {
            _this.setState({
                productos
            })
            //console.log('prods',productos)
        }).catch(_this.setState({ productos: [] }))
    }

    componentWillMount() {
        this.allProducts()
    }

    render() {
        return (
            <div className="divProductosOferta">
                {
                    this.state.productos.length === 0 ?
                        <Spinner type="grow" />
                        :
                        <Row className="rowProductosOferta">
                            {
                                this.state.productos.map(p => <Col key={p.id} xs={12} sm={6} md={4} lg={3}><ProductItem key={p.id} product={p} /></Col>)
                            }
                        </Row>

                }
            </div>
        )
    }
}